import { Component, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'pdf-viewer',
  standalone: false,
  templateUrl: './pdf-viewer.component.html'
})
export class PdfViewerComponent {

  // Pdf viewer
  @ViewChild("pdfViewer", { static: true })
  public pdfViewer;

  @Input() height: string = '100%';
  @Input() zoom: string = "80";
  @Input() src: string;
  @Input() showToolbar: boolean;
  @Input() showZoomButtons: boolean;
  @Input() showPresentationModeButton: boolean;
  @Input() showSidebarButton: boolean;
  @Input() showFindButton: boolean;
  @Input() showPagingButtons: boolean;
  @Input() showSecondaryToolbarButton: boolean;
  @Input() showRotateButton: boolean;
  @Input() showHandToolButton: boolean;
  @Input() showDownloadButton: boolean;
  @Input() showPrintButton: boolean;
  @Input() showOpenFileButton: boolean;

}
